//Content.js
import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');


export default class Desktops extends Component {

	
	constructor(props)
	{
		console.log(props);
		super(props);
		this.state = {
			desktops : [
			]
		}
		this.props = props;
		this.deleteDesktop = this.deleteDesktop.bind(this);
		this.loadDesktop = this.loadDesktop.bind(this);
		
		var currentDesktopId = 0; //props.currentUserProfile.USER_WORKSPACE_ID;
		var currentDesktopName = "current desktop"; //props.currentUserProfile.WORKSPACE_NAME;

		var currentAction = '';
		var currentActionParms = '';

	}
	setCurrentAction(action, parms)
	{
		this.currentAction = action;
		this.currentActionParms = parms;
// 		alert('set action ' + this.currentAction + ' - ' + this.currentActionParms);
// 		
// 		alert('cdm currentAction - ' + this.currentAction);

		if (this.currentAction === 'delete')
		{
// 			alert('deleting');
			this.deleteDesktop(this.currentActionParms);
		}

	}
	componentDidMount() {
		this.handleOnLoad();
	}
	
	handleOnLoad = () => {
  		axios.get(`${global.config.apiServicesUrl}/user-workspaces?filter[where][lastUpdateUser][eq]=${this.props.userId}`).then(res => {
  			const desktops = res.data;
	 	 	console.log(desktops);
  			this.setState({ desktops : res.data });
		});
	}
	deleteDesktop(desktopId)
	{
        var queryUrl = '/desktop/delete/' + desktopId;
        console.log(queryUrl);
        alert("Deleting Virtual Desktop. WARNING: This action cannot be undone!");

        fetch(queryUrl, {
            method: 'DELETE'
        }).then(function(response) {
            if (response.status >= 400) {
                throw new Error("Bad response from server");
            }
            return response.json();
        }).then(function(data) {
            //self.setState({desktops: data});
            console.log(data);
            //alert(data);
        }).catch(err => {
        console.log('caught an exception!',err);
        })

	}
	
	loadDesktop(desktopId, desktopName)
	{
		//alert('loading desktop 1 - ' + desktopId + ' 2 ' + desktopName);
		this.currentDesktopId = desktopId;		
		this.currentDesktopName = desktopName;
		this.props.currentUserProfile.WORKSPACE_NAME = desktopName;
		this.render();
	}
	
	componentDidUpdate()
	{
		var processedString = querystring.parse(this.props.location.search);
		var id = processedString.id;
		var name = processedString.name;

		//this.loadDesktop(id, name);

	}	

//  								<div class="m-portlet__head-tools">
//  									<ul class="m-portlet__nav">
// 										<li class="m-portlet__nav-item">
// 											<Link to="/desktop/create" class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--icon m-btn--air">
// 												<span>
// 													<i class="la la-plus"></i>
// 													<span>New Desktop</span>
// 												</span>
// 											</Link>
// 										</li>
// 
// 									</ul>
// 								</div>
// 

    render(){

        return (




				<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<br />
													<div class="row">
														<h3 class="col-sm-2 m-widget1__title">
															Workspaces
														</h3>
														&nbsp;
														<input class="form-control input-xlarge col-sm-6" placeholder="Filter" />
														&nbsp;
														<a href="#" class="btn btn-success">Create Workspace</a>
													</div>
							<br />
								<table class="table table-striped table-bordered table-hover table-checkable" id="m_table_1">
									<thead>
										<tr>
											<th>Id</th>
											<th>Workspace</th>
											<th>Last Updated On</th>
											<th>Actions</th>
										</tr>
									</thead>
									<tbody>
				                        <tr key={1}>
            				            <td><Link  to={`/manage-desktop?id=1`}>1</Link></td>
            				            <td><Link  to={`/manage-desktop?id=1`}>Windows Server VM (GCP) - NO GUI </Link></td>
				                        <td><Link  to={`/manage-desktop?id=1`}>August 20 2010</Link></td>
				                        <td>				                        	
				                        	<a href={`/view-desktop?location=https://34.86.132.17/#/client/MQBjAHBvc3RncmVzcWw=`} class="btn btn-info btn-sm">Desktop</a> &nbsp;  &nbsp;
				                        	<a href={`https://34.86.132.17/#/client/MQBjAHBvc3RncmVzcWw=`} target="_blank" class="btn btn-success btn-sm">Mobile</a> &nbsp;  &nbsp;
				                        	<a href="#" class="btn btn-danger btn-sm">Delete</a>				                        	
				                        	</td>
				                        </tr>
										<tr key={2}>
            				            <td><Link  to={`/manage-desktop?id=2`}>2</Link></td>
            				            <td><Link  to={`/manage-desktop?id=2`}>Windows Server VM (GCP) - Fortnite </Link></td>
				                        <td><Link  to={`/manage-desktop?id=2`}>August 20 2010</Link></td>
				                        <td>				                        	
				                        	<a href={`/view-desktop?location=https://34.86.132.17/#/client/MgBjAHBvc3RncmVzcWw=`} class="btn btn-info btn-sm">Desktop</a> &nbsp;  &nbsp;
				                        	<a href={`https://34.86.132.17/#/client/MgBjAHBvc3RncmVzcWw=`} target="_blank" class="btn btn-success btn-sm">Mobile</a> &nbsp;  &nbsp;
				                        	<a href="#" class="btn btn-danger btn-sm">Delete</a>				                        	
				                        	</td>
				                        </tr>
									{this.state.desktops.map(desktop =>
				                        <tr key={desktop.userWorkspaceId}>
            				            <td><Link  to={`/manage-desktop?id=${desktop.userWorkspaceId}`}>{desktop.userWorkspaceId}</Link></td>
            				            <td><Link  to={`/manage-desktop?id=${desktop.userWorkspaceId}`}>{desktop.workspaceName} </Link></td>
				                        <td><Link  to={`/manage-desktop?id=${desktop.userWorkspaceId}`}>{String(desktop.lastUpdateDate).substring(0,16).replace('T',' ')}</Link></td>
				                        <td>				                        	
				                        	<a href="/view-desktop" class="btn btn-warning btn-sm">Load</a>&nbsp; &nbsp; 
				                        	<a href={`/view-desktop?id=${desktop.userWorkspaceId}`} class="btn btn-info btn-sm">Desktop</a> &nbsp;  &nbsp;
				                        	<a href={`/view-desktop?id=${desktop.userWorkspaceId}`} class="btn btn-success btn-sm">Mobile</a> &nbsp;  &nbsp;
				                        	<a href="#" class="btn btn-danger btn-sm">Delete</a>				                        	
				                        	</td>
				                        </tr>
									)}
									</tbody>
								</table>
												</div>

											</div>
						</div>
            </div>
            
			</div>
			</div>
			


			);
		}
	}